import { FC, useMemo, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import Typography from 'components/commercetools-ui/atoms/typography';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { smallMobile, desktop, tablet, mediumDesktop } from 'helpers/utils/screensizes';
import MultiPageContentPage from './page';
import { MultiPageContentProps } from './types';
import Wrapper from '../../../HOC/wrapper';
import Subtitle from '../../atoms/subtitle';

const MultiPageContent: FC<MultiPageContentProps> = ({ title, subtitle, pages, backgroundColor }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pagesElement = useMemo(
    () =>
      pages.map((page, index) => (
        <MultiPageContentPage key={page.title} className={`${currentPage === index ? 'block' : 'hidden'}`} {...page} />
      )),
    [pages, currentPage],
  );

  return (
    <div style={{ backgroundColor: backgroundColor }}>
      <div className="px-32 py-60 xl:mx-auto xl:max-w-[1200px] xl:px-0">
        {title && (
          <Typography className="text-28 font-medium text-primary-black md:w-1/2 md:text-40" as="h3">
            {title}
          </Typography>
        )}
        <div className="my-24 border-neutral-500 md:my-48 md:w-1/2 md:border-b"></div>
        {subtitle && <Subtitle className="mb-24" subtitle={subtitle} />}
        <div className="relative w-full">{pagesElement}</div>
        <div className="flex items-center justify-start md:mt-0">
          <button
            aria-label="Go back"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 0}
            className="flex size-36 cursor-pointer items-center justify-center rounded-full border border-gray-400 bg-white disabled:opacity-50"
          >
            <ArrowLeftIcon className="size-20 stroke-gray-400" />
          </button>
          <div className="mx-10 w-48 text-center">
            {currentPage + 1} of {pages.length}
          </div>
          <button
            aria-label="Go forward"
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === pages.length - 1}
            className="flex size-36 cursor-pointer items-center justify-center rounded-full border border-gray-400 bg-white disabled:opacity-50"
          >
            <ArrowRightIcon className="size-20 stroke-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
};
export default MultiPageContent;

export * from './types';
